@if (noDataToDisplay()) {
  <div class="no-data-el" data-cy="chart-no-data-message">{{ 'charts.noData' | translate }}</div>
} @else {
 @if (chartOptions) {
   <apx-chart
     [series]="chartOptions.series"
     [chart]="chartOptions.chart"
     [xaxis]="chartOptions.xaxis"
     [yaxis]="chartOptions.yaxis"
     [dataLabels]="chartOptions.dataLabels"
     [grid]="chartOptions.grid"
     [stroke]="chartOptions.stroke"
     [legend]="chartOptions.legend"
     [fill]="chartOptions.fill"
     [tooltip]="chartOptions.tooltip"
     [markers]="chartOptions.markers"
     [plotOptions]="chartOptions.plotOptions!"
   ></apx-chart>
 }
}
